/**
 * H1 sticky ATC: color and capacity controls use the main product's variant picker.
 */
(function () {
  if (window.__productStickyFormH1) return;
  window.__productStickyFormH1 = true;

  function syncLayoutVariant() {
    var layout = new URL(window.location.href).searchParams.get('sticky_atc');
    document.documentElement.dataset.stickyAtcVariant = layout === '1' || layout === '3' ? layout : '2';
  }

  syncLayoutVariant();
  window.addEventListener('popstate', syncLayoutVariant);

  if (window.theme?.pubsub?.subscribe) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function ({ data }) {
      const sticky = document.querySelector('product-sticky-form.product-sticky-form-h1');
      const media = sticky?.querySelector('[data-sticky-product-media]');
      const source = media && data?.parsedHTML?.getElementById(media.id);
      const sourceImage = source?.querySelector('img');
      if (!sourceImage) return;
      // Run after the theme's synchronous variant handler, which also replaces
      // this image. A lazy-image removed by that handler can leave loading stuck.
      queueMicrotask(function () {
        if (!media.isConnected) return;
        const image = document.createElement('img');
        Array.from(sourceImage.attributes).forEach(function (attribute) {
          if (attribute.name !== 'is' && attribute.name !== 'loading') {
            image.setAttribute(attribute.name, attribute.value);
          }
        });
        image.loading = 'eager';
        media.classList.remove('loading');
        media.replaceChildren(image);
      });
    });
  }

  function escapeValue(value) {
    if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(value);
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function findOptionRadio(control, value) {
    var sticky = control.closest('product-sticky-form');
    var section = sticky && document.getElementById('shopify-section-' + sticky.dataset.sectionId);
    var picker = section && section.querySelector('variant-picker');
    if (!picker || !value) return null;
    var safe = escapeValue(value);
    var optionIndex = Number(control.dataset.optionIndex) + 1;
    return (
      picker.querySelector('input[data-option-index="' + optionIndex + '"][data-option-value="' + safe + '"]')
    );
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-sticky-size-select]');
    if (!select) return;

    var radio = findOptionRadio(select, select.value);
    if (!radio || radio.checked) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-sticky-size-toggle], [data-sticky-color-toggle]');
    if (!toggle || toggle.disabled) return;
    var radio = findOptionRadio(toggle, toggle.dataset.value);
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !variant.options) return;

    document.querySelectorAll('[data-sticky-color-toggle]').forEach(function (toggle) {
      var optionIndex = parseInt(toggle.dataset.optionIndex, 10) || 0;
      toggle.setAttribute('aria-current', String(variant.options[optionIndex] === toggle.dataset.value));
    });

    document.querySelectorAll('[data-sticky-size-toggle]').forEach(function (toggle) {
      var optionIndex = parseInt(toggle.dataset.optionIndex, 10) || 0;
      toggle.setAttribute('aria-pressed', String(variant.options[optionIndex] === toggle.dataset.value));
    });

    document.querySelectorAll('[data-sticky-size-select]').forEach(function (select) {
      var optionIndex = parseInt(select.getAttribute('data-option-index'), 10) || 0;
      var next = variant.options[optionIndex];
      if (next && select.value !== next) select.value = next;
    });
  }, true);

  /**
   * Keep the Shopify Inbox chat activator clear of this bar.
   *
   * The Inbox app embed anchors the activator with --shopify-chat-activator-offset
   * (120px on :root) and the widget reads that variable from inside its shadow
   * root, so page CSS cannot style .activator-nudge itself. The bar is taller than
   * 120px, so while the card is on screen the activator is raised to sit just
   * above it; once the card is hidden the app's own value comes back.
   */
  var INBOX_GAP = 20;
  var inboxApplied = '';
  var inboxObserved = null;
  var inboxObserver =
    window.MutationObserver &&
    new MutationObserver(function () {
      syncInboxOffset();
    });

  // The theme reveals the card through Motion inline styles and the flick handler
  // toggles a class, so watch both instead of trusting scroll events alone.
  function watchBar(bar, card) {
    if (!inboxObserver || inboxObserved === bar) return;
    inboxObserved = bar;
    inboxObserver.disconnect();
    inboxObserver.observe(bar, { attributes: true, attributeFilter: ['class'] });
    if (card) inboxObserver.observe(card, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  function syncInboxOffset() {
    var bar = document.querySelector('.product-sticky-form-h1');
    var card = bar && bar.querySelector('.product-sticky-form-h1__card');
    if (!card) return;

    watchBar(bar, card);

    var next = '';
    if (getComputedStyle(card).visibility === 'visible') {
      var barBottom = parseFloat(getComputedStyle(bar).bottom) || 0;
      next = Math.ceil(card.getBoundingClientRect().height + barBottom + INBOX_GAP) + 'px';
    }
    if (next === inboxApplied) return;

    inboxApplied = next;
    if (next) {
      document.documentElement.style.setProperty('--shopify-chat-activator-offset', next);
    } else {
      document.documentElement.style.removeProperty('--shopify-chat-activator-offset');
    }
  }

  /**
   * Hide the bar on a fast flick upwards, bring it back as soon as the reader
   * scrolls down again. The theme only hides it above the fold or at the footer.
   */
  var HIDE_CLASS = 'is-scroll-hidden';
  var FLICK_DISTANCE = 200; // px travelled up
  var FLICK_WINDOW = 300; // within this many ms

  var lastY = window.scrollY;
  var lastTime = 0;
  var flickStart = 0;
  var flickDistance = 0;
  var queued = false;

  function measure() {
    queued = false;

    var bar = document.querySelector('.product-sticky-form-h1');
    if (!bar) return;

    var form = bar.scopeFrom;
    var footer = bar.scopeTo;
    if (form && footer && typeof bar.handleIntersection === 'function') {
      var formRect = form.getBoundingClientRect();
      var footerRect = footer.getBoundingClientRect();
      var formPassed = formRect.bottom < 0;
      var footerReached = footerRect.top < window.innerHeight && footerRect.bottom > 0;
      if (bar.scopeFromPassed !== formPassed || bar.scopeToReached !== footerReached) {
        bar.handleIntersection([
          { target: form, boundingClientRect: formRect, isIntersecting: !formPassed },
          { target: footer, boundingClientRect: footerRect, isIntersecting: footerReached }
        ]);
      }
    }

    syncInboxOffset();

    var y = window.scrollY;
    var now = performance.now();
    var delta = y - lastY;
    lastY = y;

    if (delta >= 0) {
      flickDistance = 0;
      if (delta > 0) bar.classList.remove(HIDE_CLASS);
      lastTime = now;
      return;
    }

    // A pause between upward moves starts a new flick.
    if (now - lastTime > FLICK_WINDOW || now - flickStart > FLICK_WINDOW) {
      flickStart = now;
      flickDistance = 0;
    }
    lastTime = now;

    flickDistance += -delta;
    if (flickDistance >= FLICK_DISTANCE) bar.classList.add(HIDE_CLASS);
  }

  window.addEventListener(
    'scroll',
    function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(measure);
    },
    { passive: true }
  );

  window.addEventListener('resize', syncInboxOffset, { passive: true });
  document.addEventListener('variant:change', syncInboxOffset);
  syncInboxOffset();
})();
